import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const authApi = {
  session: (sessionId) => http.post("/auth/session", null, { headers: { "X-Session-ID": sessionId } }),
  register: (email, password, name) => http.post("/auth/register", { email, password, name }),
  login: (email, password) => http.post("/auth/login", { email, password }),
  forgot: (email) => http.post("/auth/forgot", { email }),
  reset: (token, new_password) => http.post("/auth/reset", { token, new_password }),
  me: () => http.get("/auth/me"),
  logout: () => http.post("/auth/logout"),
};

export const publicApi = {
  joinWaitlist: (email, source = "landing", ref = null) => http.post("/waitlist", { email, source, ref }),
  waitlistDetails: (email, business_idea) => http.post("/waitlist/details", { email, business_idea }),
  waitlistCount: () => http.get("/waitlist/count"),
};

export const adminApi = {
  listWaitlist: () => http.get("/admin/waitlist"),
  invite: (email) => http.post(`/admin/waitlist/${encodeURIComponent(email)}/invite`),
};

export const soloApi = {
  saveOnboarding: (data) => http.post("/onboarding", data),
  standup: () => http.get("/standup"),
  chatSend: (message, agent = "ceo") => http.post("/chat/send", { message, agent }),
  chatHistory: (agent = "ceo") => http.get(`/chat/history?agent=${agent}`),
  approvals: () => http.get("/approvals"),
  decide: (taskId, decision, edits) => http.post(`/approvals/${taskId}`, { decision, edits }),
  marketerDraft: (topic, tone, withImage) => http.post("/marketer/draft-post", { topic, tone, with_image: withImage }),
  leads: () => http.get("/leads"),
  createLead: (data) => http.post("/leads", data),
  moveLead: (leadId, stage) => http.post(`/leads/${leadId}/stage?stage=${stage}`),
  draftOutreach: (leadId) => http.post(`/sales/draft-outreach?lead_id=${leadId}`),
  transactions: () => http.get("/transactions"),
  createTransaction: (data) => http.post("/transactions", data),
  accountantSummary: () => http.get("/accountant/summary"),
  cpas: () => http.get("/accountant/cpas"),
};
